import ErrorIcon from '@mui/icons-material/Error';
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSnackbar } from '../../context/SnackbarContext';
import { COMPANY_PDP, FLAG_REDIRECT_FROM_PREVIEW, getDashboardTab, getInvestorReportPath, getItem, LS_INV_CODE, setDashboardTab } from "../../utils/LocalStorageUtils";
import { getDashboard, getUserDetails, getVoteListApi } from "../apis/apis";
import DashboardContent from "../components/DashboardContent";
import Footer from "../components/Footer";
import Graph from "../components/Graph";
import InvestmentContainer from "../components/InvestmentContainer";
import NavBar from "../components/NavBar";
import AllActivity from "./AllActivity";
import Commitments from "./Commitments";
import Opportunites from "./Opportunities";
import VotingPage from "./voting/VotingPage";

const tabStyle = {
  borderBottom: "1px solid rgba(0, 0, 0, 0.175)",
};

function HomePage(props) {

  const history = useHistory();
  const [tabIndex, setTabIndex] = useState(0);
  const [investmentByRounds, setInvestmentByRounds] = useState([]);
  const [cardData, setCardData] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [voteAlert, setVoteAlert] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleTab = (value) => {
    setTabIndex(value);
    setDashboardTab(value?.toString());
  };

  const fetchUserData = async () => {
    const userDetails = await getUserDetails();
    if (userDetails.status) {
      const {
        mcaStatus, ckycStatus, investorSip,
        fullName, email, mobile, countryCode,
        dobDoi, address, investorType, cityRid, countryRid,
        bankName, bankIndex, bankAddress, accountNo, ifscSwift, isAccredited, loginEnabled, otherBankName
      } = userDetails.data;

      if (!isAccredited) {
        history.push("/user/accreditation-disclosure");
        return;
      } else if (!ckycStatus) {
        history.push("/user/successfull");
        return;
      } else if (
        (dobDoi === null || dobDoi === "") ||
        (address === null || address === "") ||
        (investorType === null || investorType === "") ||
        (cityRid === 0) || (countryRid === 0)
      ) {
        history.push("/user/communication-details");
        return;
      } else if (
        ((bankName === '' || bankName === null) && (bankIndex === 0 || bankIndex === null) &&
          (otherBankName === '' || otherBankName === null)) ||
        (bankAddress === '' || bankAddress === null) ||
        (accountNo === '' || accountNo === null) ||
        (ifscSwift === '' || ifscSwift === null)
      ) {
        history.push("/user/bank-details");
        return;
      }
      else if (mcaStatus === 0) {
        history.push("/user/successfull");
        return;
      } else if (loginEnabled === 0 && !getItem(FLAG_REDIRECT_FROM_PREVIEW)) {
        showSnackbar("You are not authorized to access this resource");
        localStorage.clear();
        history.replace("/");
      } else {
        history.replace("/user/home"); return;
      }

      localStorage.setItem("fullName", fullName);
      localStorage.setItem("email", email);
      localStorage.setItem("mobileNumber", mobile);
      localStorage.setItem("countryCode", countryCode);
      localStorage.setItem("dialCode", countryCode);
      localStorage.setItem(LS_INV_CODE, userDetails?.data.invCode);

      // if (!ckycStatus) {
      //   setAlertMessage("Complete your CKYC process");
      // } else if (!mcaStatus !== 0) {
      //   setAlertMessage("Complete your MCA process");
      // } else if (
      //   investorSip !== null &&
      //   investorSip?.enachStatus !== process.env.REACT_APP_ENACH_STATUS_INPROGRESS
      // ) {
      //   setAlertMessage("Complete your SIP E-Nach process");
      // }

      // setShowAlertBar(
      //   !ckycStatus ||
      //   !mcaStatus ||
      //   (investorSip !== null &&
      //     investorSip?.enachStatus !== process.env.REACT_APP_ENACH_STATUS_INPROGRESS)
      // );

      if (getInvestorReportPath()) {
        history.replace(getInvestorReportPath());
        localStorage.removeItem("investor_report_path");
      }



    }
  };

  const getDashboardData = async () => {
    const dashboardData = await getDashboard();

    if (dashboardData.status) {
      const {
        invByRoundList,
        graphList,
        noOfInvestments,
        noOfOpportunity,
        portfolioValue,
        totalInvestedAmount,
        multiple,
      } = dashboardData?.data;
      setInvestmentByRounds(invByRoundList);
      setGraphData(graphList);
      setCardData({
        noOfInvestments,
        noOfOpportunity,
        portfolioValue,
        totalInvestedAmount,
        multiple,
      });
    }
    setLoading(false);
  };

  const getVoteList = () => {
    getVoteListApi()
      .then((res) => {
        const hasActiveVote = res.voteList.some(item => item.isClosed === 0);
        setVoteAlert(hasActiveVote);
      })
      .catch((err) => {
        console.error("Error fetching votes:", err);
      });
  };

  useEffect(() => {
    if (getItem(COMPANY_PDP)) {
      history.replace("/user/company-pdp/" + parseInt(getItem(COMPANY_PDP)));
    }

    fetchUserData();
    getDashboardData();

    if (getDashboardTab() !== null) {
      if (parseInt(getDashboardTab()) === 0) {
        setDashboardTab("0");
      } else {
        setTabIndex(parseInt(getDashboardTab()));
      }
    }
    getVoteList();
  }, []);

  return (
    <div>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-absolute"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : (
        <div className="vh-100 d-flex flex-column">
          <NavBar />
          <div className="container-fluid flex-grow-1 overflow-auto">
            <div className="container mx-auto px-3">
              <Box className="mt-4" style={tabStyle}>
                <Tabs value={tabIndex} onChange={(e, v) => handleTab(v)}>
                  <Tab value={0} label="Dashboard" className="fs-med-medium" />
                  <Tab value={1} label="Opportunities" className="fs-med-medium" />
                  <Tab value={3} label="Commitments" className="fs-med-medium" />
                  <Tab value={2} label="Activity" className="fs-med-medium " />
                  <Tab
                    value={4}
                    label={
                      <span>
                        Vote{" "}
                        {voteAlert ? (
                          <ErrorIcon sx={{ fontSize: 17, color: "red" }} />
                        ) : null}
                      </span>
                    }
                    className="fs-med-medium"
                  />
                </Tabs>
              </Box>

              {tabIndex === 0 && (
                <>
                  <Graph cardData={cardData} graphData={graphData} />
                  <DashboardContent
                    handleTab={handleTab}
                    investmentByRounds={investmentByRounds}
                  />
                  <InvestmentContainer />
                </>
              )}

              {tabIndex === 1 && <Opportunites />}
              {tabIndex === 2 && <AllActivity />}
              {tabIndex === 3 && <Commitments />}
              {tabIndex === 4 && <VotingPage />}
            </div>
          </div>
          <Footer />
        </div>
      )}
    </div>
  );
}

export default HomePage;
